"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isOnlyOneSizeProduct = exports.isOneSizeProduct = exports.getDeliveryCharge = exports.getProductGroupUniqueIds = exports.makeProductGroupObjects = exports.fixProductColoursFallback = exports.mergeProductDetailPriceToProductLister = exports.mergeProductAvailabilitiesToProductLister = exports.mergeProductAvailabilityToProductLister = exports.mergeProductFeatures = exports.mergeProductPricesToProductLister = exports.mapAllPricesToZeroForProductColorVariations = exports.mapSkuPrices = exports.mapColorPrices = exports.mapSkuAvailability = exports.mapColorAvailability = exports.mapProductAvailabilityToProductColorVariations = exports.mapProductPriceToProductColorVariations = exports.determineSelectedColorId = exports.checkSizesAndSetDefaultSku = exports.determineSelectedSku = exports.setSKUDynamicSavings = exports.setSkuAvailability = exports.setSkuPrices = exports.setColorAvailability = exports.findSize = void 0;
exports.findColor = findColor;
exports.findSizeBySku = findSizeBySku;
const general_util_1 = require("./general.util");
const price_util_1 = require("./price.util");
function findColor(colors, colorId) {
    return (colors === null || colors === void 0 ? void 0 : colors.find(color => (color.colorId || color.colourId) === Number(colorId))) || null;
}
function findSizeBySku(sizes, sku) {
    return (sizes === null || sizes === void 0 ? void 0 : sizes.find((size) => (size.sku || size.skuId).toString() === sku)) || null;
}
const findSize = (sizes, sizeCode) => (sizes === null || sizes === void 0 ? void 0 : sizes.find((size) => size.code === sizeCode)) || null;
exports.findSize = findSize;
const setColorAvailability = (productAvailability, colorId) => {
    var _a;
    const colorAvailability = (_a = productAvailability === null || productAvailability === void 0 ? void 0 : productAvailability.colorAvailabilities) === null || _a === void 0 ? void 0 : _a.find(item => item.colorId === colorId);
    if ((0, general_util_1.isNullOrUndefined)(colorAvailability)) {
        return {};
    }
    return {
        availability: colorAvailability.availability,
        alwaysVisible: colorAvailability.alwaysVisible,
    };
};
exports.setColorAvailability = setColorAvailability;
const getColorPrice = (productPrice, colorId) => {
    return productPrice.colours && productPrice.colours.find(item => item.colourId === colorId);
};
const setSkuPrices = (productPrice, colorId, productColorVariationSize) => {
    const colorPrice = getColorPrice(productPrice, colorId);
    if ((0, general_util_1.isNullOrUndefined)(colorPrice)) {
        return {};
    }
    const skuPrice = colorPrice.skus.find(item => item.skuId.toString() === productColorVariationSize.sku && productColorVariationSize.active);
    if ((0, general_util_1.isNullOrUndefined)(skuPrice)) {
        return {};
    }
    return {
        prices: skuPrice ? (0, price_util_1.mapEdgePriceToPricesObject)(skuPrice) : null,
    };
};
exports.setSkuPrices = setSkuPrices;
const setSkuAvailability = (productAvailability, colorId, productColorVariationSize) => {
    var _a, _b;
    const colorAvailability = (_a = productAvailability === null || productAvailability === void 0 ? void 0 : productAvailability.colorAvailabilities) === null || _a === void 0 ? void 0 : _a.find(item => item.colorId === colorId);
    if ((0, general_util_1.isNullOrUndefined)(colorAvailability)) {
        return {};
    }
    const skuAvailability = (_b = colorAvailability === null || colorAvailability === void 0 ? void 0 : colorAvailability.skuAvailabilities) === null || _b === void 0 ? void 0 : _b.find(item => item.skuCode === productColorVariationSize.sku && productColorVariationSize.active);
    if ((0, general_util_1.isNullOrUndefined)(skuAvailability)) {
        return {};
    }
    return {
        availability: skuAvailability.availability,
        lastPieces: skuAvailability.lastPieces,
        exactAvailability: skuAvailability.exactAvailability,
    };
};
exports.setSkuAvailability = setSkuAvailability;
const setSKUDynamicSavings = (productPrice, colorId, productColorVariationSize) => {
    const colorPrice = getColorPrice(productPrice, colorId);
    if ((0, general_util_1.isNullOrUndefined)(colorPrice)) {
        return {};
    }
    const skuPrice = colorPrice.skus.find(item => item.skuId.toString() === productColorVariationSize.sku && productColorVariationSize.active);
    if ((0, general_util_1.isNullOrUndefined)(skuPrice)) {
        return {};
    }
    return {
        productDiscountPercentage: skuPrice.productDiscountPercentage,
        productDiscountAmount: skuPrice.productDiscountAmount,
    };
};
exports.setSKUDynamicSavings = setSKUDynamicSavings;
const determineSelectedSku = (productColors, selectedSku, allowSelectSoldOutSizes) => {
    var _a;
    const filteredSizes = (_a = productColors.sizes) === null || _a === void 0 ? void 0 : _a.filter(size => allowSelectSoldOutSizes
        ? (size.active && size.availability > 0) ||
            (size.active && size.availability <= 0 && size.historicAvailable && !size.storeSourceExcluded)
        : size.active && size.availability > 0);
    if (filteredSizes && filteredSizes.length === 1) {
        return filteredSizes[0].sku;
    }
    if (selectedSku) {
        const selectedSize = filteredSizes === null || filteredSizes === void 0 ? void 0 : filteredSizes.find(size => size.sku === selectedSku);
        return selectedSize && selectedSize.active && selectedSize.availability && selectedSize.availability > 0
            ? selectedSku
            : null;
    }
    return null;
};
exports.determineSelectedSku = determineSelectedSku;
const checkSizesAndSetDefaultSku = (selectedColorId, colors, selectedSku, allowSelectSoldOutSizes) => {
    const selectedColor = colors.find((color) => color.colorId === selectedColorId);
    if (!selectedColor) {
        return null;
    }
    return (0, exports.determineSelectedSku)(selectedColor, selectedSku, allowSelectSoldOutSizes);
};
exports.checkSizesAndSetDefaultSku = checkSizesAndSetDefaultSku;
const determineSelectedColorId = (product, productColor) => {
    var _a, _b;
    let selectedColorVariation;
    let requestedColorVariation;
    const activeAndVisibleColors = (_a = product.productColorVariations) === null || _a === void 0 ? void 0 : _a.filter((colorVariation) => colorVariation.visible && colorVariation.active);
    const defaultColorVariation = (_b = product.productColorVariations) === null || _b === void 0 ? void 0 : _b.find((colorVariation) => product.defaultColor === colorVariation.colorId);
    if (!(0, general_util_1.isNullOrUndefined)(productColor) &&
        !isNaN(parseInt(productColor, 10)) &&
        activeAndVisibleColors &&
        activeAndVisibleColors.length > 0) {
        requestedColorVariation = activeAndVisibleColors.find((colorVariation) => parseInt(productColor, 10) === colorVariation.colorId);
    }
    if (requestedColorVariation) {
        selectedColorVariation = requestedColorVariation;
    }
    else if (defaultColorVariation && defaultColorVariation.active && defaultColorVariation.visible) {
        selectedColorVariation = defaultColorVariation;
    }
    else if (activeAndVisibleColors && activeAndVisibleColors.length > 0) {
        selectedColorVariation = activeAndVisibleColors[0];
    }
    else {
        selectedColorVariation = defaultColorVariation || { colorId: null }; // Select default color anyway when nothing else is active/visible
    }
    return {
        productColorVariations: [
            selectedColorVariation,
            ...product.productColorVariations.filter((productColorVariation) => productColorVariation.colorId !== selectedColorVariation.colorId),
        ],
        selectedColorId: selectedColorVariation.colorId,
    };
};
exports.determineSelectedColorId = determineSelectedColorId;
const setColorPrices = (productPrice, colorId) => {
    const colorPrice = productPrice.colours && productPrice.colours.find(item => item.colourId === colorId);
    if ((0, general_util_1.isNullOrUndefined)(colorPrice)) {
        return {};
    }
    return {
        hasDifferentPrices: colorPrice.colourHasDifferentPrices,
        hasDiscount: colorPrice.priceState === 2 ||
            colorPrice.priceState === 3 ||
            colorPrice.priceState === 4 ||
            colorPrice.priceState === 5,
        markdown: colorPrice.markdown,
        prices: (0, price_util_1.mapEdgePriceToPricesObject)(colorPrice),
        priceOverlay: {
            overlayCode: colorPrice.webThumbOverlayCode,
            overlayThumb: colorPrice.webThumbOverlayPicture,
        },
    };
};
const setDynamicSavings = (productPrice, colorId) => {
    const colorPrice = productPrice.colours && productPrice.colours.find(item => item.colourId === colorId);
    if ((0, general_util_1.isNullOrUndefined)(colorPrice)) {
        return {};
    }
    return {
        colourDiscountPercentage: colorPrice.colourDiscountPercentage,
        colourDiscountAmount: colorPrice.colourDiscountAmount,
    };
};
const mapProductPriceToProductColorVariations = (productColorVariations, productPrice) => {
    return productColorVariations.map(productColorVariation => (Object.assign(Object.assign(Object.assign(Object.assign({}, productColorVariation), setColorPrices(productPrice, productColorVariation.colorId)), setDynamicSavings(productPrice, productColorVariation.colorId)), { sizes: productColorVariation.sizes
            ? productColorVariation.sizes.map(size => (Object.assign(Object.assign(Object.assign({}, size), (0, exports.setSkuPrices)(productPrice, productColorVariation.colorId, size)), (0, exports.setSKUDynamicSavings)(productPrice, productColorVariation.colorId, size))))
            : [] })));
};
exports.mapProductPriceToProductColorVariations = mapProductPriceToProductColorVariations;
const mapProductAvailabilityToProductColorVariations = (productColorVariations, productAvailability) => {
    return productColorVariations.map((productColorVariation) => {
        return Object.assign(Object.assign(Object.assign({}, productColorVariation), (0, exports.setColorAvailability)(productAvailability, productColorVariation.colorId)), { sizes: productColorVariation.sizes
                ? productColorVariation.sizes.map((size) => (Object.assign(Object.assign({}, size), (0, exports.setSkuAvailability)(productAvailability, productColorVariation.colorId, size))))
                : [] });
    });
};
exports.mapProductAvailabilityToProductColorVariations = mapProductAvailabilityToProductColorVariations;
const mapColorAvailability = (colorAvailability) => {
    if (!colorAvailability) {
        return {};
    }
    return {
        alwaysVisible: colorAvailability.alwaysVisible,
        availability: colorAvailability.availability,
    };
};
exports.mapColorAvailability = mapColorAvailability;
const mapSkuAvailability = (skuAvailability) => {
    if (!skuAvailability) {
        return {};
    }
    return {
        availability: skuAvailability.availability,
        exactAvailability: skuAvailability.exactAvailability,
        lastPieces: skuAvailability.lastPieces,
    };
};
exports.mapSkuAvailability = mapSkuAvailability;
const mapColorPrices = (priceDataForColor) => {
    if (!priceDataForColor) {
        return {};
    }
    return {
        colourDiscountAmount: priceDataForColor.discountAmount,
        colourDiscountPercentage: priceDataForColor.discountPercentage,
        hasDifferentPrices: priceDataForColor.hasDifferentPrices,
        hasDiscount: priceDataForColor.hasDiscount,
        markdown: priceDataForColor.markdown,
        prices: priceDataForColor.prices,
        priceOverlay: priceDataForColor.priceOverlay
            ? {
                overlayCode: priceDataForColor.priceOverlay.code,
                overlayThumb: priceDataForColor.priceOverlay.thumb,
                idOverlayBackground: priceDataForColor.priceOverlay.idOverlayBackground,
                overlayBackgroundCodeDescription: priceDataForColor.priceOverlay.overlayBackgroundCodeDescription,
            }
            : {},
    };
};
exports.mapColorPrices = mapColorPrices;
const mapSkuPrices = (priceDataForColorSize) => {
    if (!priceDataForColorSize) {
        return {};
    }
    return {
        prices: priceDataForColorSize.prices,
        productDiscountAmount: priceDataForColorSize.discountAmount,
        productDiscountPercentage: priceDataForColorSize.discountPercentage,
    };
};
exports.mapSkuPrices = mapSkuPrices;
const setSellPricesToZero = (prices) => {
    const sellPrice = {
        original: 0.0,
    };
    if (!prices) {
        return {};
    }
    else if (!prices.STD && !prices.RRP) {
        return {
            hasDiscount: true,
            prices: {
                SELL: sellPrice,
                STD: Object.assign({}, prices.SELL),
            },
        };
    }
    return {
        prices: Object.assign(Object.assign({}, prices), { SELL: sellPrice }),
    };
};
const mapAllPricesToZeroForProductColorVariations = (productColorVariations) => {
    return productColorVariations.map((color) => (Object.assign(Object.assign(Object.assign({}, color), setSellPricesToZero(color.prices)), { sizes: color.sizes
            ? color.sizes.map((size) => (Object.assign(Object.assign({}, size), setSellPricesToZero(size.prices))))
            : [] })));
};
exports.mapAllPricesToZeroForProductColorVariations = mapAllPricesToZeroForProductColorVariations;
const mergeProductPricesToProductLister = (product, productPrice) => {
    const productColours = product.colours.map(colour => (Object.assign(Object.assign({}, colour), { sizes: colour.sizes.map(size => {
            const color = findColor(productPrice === null || productPrice === void 0 ? void 0 : productPrice.colours, colour.colourId);
            const skuPrice = (color === null || color === void 0 ? void 0 : color.skus) ? findSizeBySku(color === null || color === void 0 ? void 0 : color.skus, size.sku) : null;
            return Object.assign(Object.assign({}, size), { prices: skuPrice ? (0, price_util_1.mapEdgePriceToPricesObject)(skuPrice) : null, productDiscountPercentage: skuPrice ? skuPrice.productDiscountPercentage : null, productDiscountAmount: skuPrice ? skuPrice.productDiscountAmount : null });
        }) })));
    return Object.assign(Object.assign({}, product), { colours: productColours, ccExcluded: productPrice.ccExcluded, hdExcluded: productPrice.hdExcluded });
};
exports.mergeProductPricesToProductLister = mergeProductPricesToProductLister;
const mergeProductFeatures = (products, productsFeaturesRecord, maxProductsSize, currentProductId, maxFeatures) => {
    if (productsFeaturesRecord && Object.keys(productsFeaturesRecord).length <= 1) {
        return products.slice(1);
    }
    const featuresMap = currentProductId
        ? new Map(productsFeaturesRecord[currentProductId].map(feature => [feature.featureId, feature]))
        : Object.entries(productsFeaturesRecord)
            .flatMap(([, features]) => features)
            .reduce((acc, feature, index) => (maxFeatures && index > maxFeatures ? acc : acc.set(feature.featureId, feature)), new Map());
    if (featuresMap.size <= 0) {
        return products.slice(1);
    }
    let productsFeaturesOverlap = false;
    const productsWithFeatures = products.map(product => {
        const { productId } = product;
        const existingProductFeatures = productsFeaturesRecord[productId];
        const features = Array.from(featuresMap.values()).map(defaultFeature => {
            const existingFeature = existingProductFeatures === null || existingProductFeatures === void 0 ? void 0 : existingProductFeatures.find(feature => feature.featureId === defaultFeature.featureId);
            if (existingFeature && productId !== currentProductId) {
                productsFeaturesOverlap = true;
            }
            return existingFeature
                ? Object.assign(Object.assign({}, existingFeature), { attributeValue: existingFeature.featureType === 'BOOLEAN'
                        ? existingFeature.attributeValue === '1'
                        : existingFeature.attributeValue }) : Object.assign(Object.assign({}, defaultFeature), { attributeValue: null });
        });
        return Object.assign(Object.assign({}, product), { features });
    });
    // If there are no overlapping features with the current product, we can remove the current product from the list
    if (!productsFeaturesOverlap) {
        return products.slice(1);
    }
    let productsToRemove = productsWithFeatures.length - maxProductsSize;
    // Remove products that don't have any features in common with the current product based on maxProductsSize
    return productsWithFeatures
        .filter(product => {
        if (productsToRemove > 0 && !product.features.some(feature => feature.attributeValue)) {
            productsToRemove--;
            return false;
        }
        return true;
    })
        .slice(0, maxProductsSize);
};
exports.mergeProductFeatures = mergeProductFeatures;
const mergeProductAvailabilityToProductLister = (product, productAvailability) => {
    const productColours = product.colours.map(colour => {
        var _a;
        const colorAvailability = ((_a = productAvailability === null || productAvailability === void 0 ? void 0 : productAvailability.colorAvailabilities) === null || _a === void 0 ? void 0 : _a.find(color => color.colorId === colour.colourId)) || null;
        return Object.assign(Object.assign({}, colour), { availability: colorAvailability === null || colorAvailability === void 0 ? void 0 : colorAvailability.availability, alwaysVisible: colorAvailability === null || colorAvailability === void 0 ? void 0 : colorAvailability.alwaysVisible, sizes: colour.sizes.map(size => {
                const skuAvailability = colorAvailability
                    ? colorAvailability.skuAvailabilities.find(sizeAvailability => sizeAvailability.skuCode === size.sku)
                    : null;
                return Object.assign(Object.assign({}, size), { availability: skuAvailability ? skuAvailability.availability : null, exactAvailability: skuAvailability ? skuAvailability.exactAvailability : null, lastPieces: skuAvailability ? skuAvailability.lastPieces : null });
            }) });
    });
    return Object.assign(Object.assign({}, product), { availability: productAvailability.availability, alwaysVisible: productAvailability.alwaysVisible, colours: productColours });
};
exports.mergeProductAvailabilityToProductLister = mergeProductAvailabilityToProductLister;
const mergeProductAvailabilitiesToProductLister = (products, productAvailabilities) => {
    return products.map(product => {
        const productAvailability = productAvailabilities.find(availability => product.productId === availability.productId);
        if (productAvailability) {
            return (0, exports.mergeProductAvailabilityToProductLister)(product, productAvailability);
        }
        return product;
    });
};
exports.mergeProductAvailabilitiesToProductLister = mergeProductAvailabilitiesToProductLister;
const mergeProductDetailPriceToProductLister = (product, productPrice) => {
    var _a, _b;
    const productColours = product.colours.map(colour => (Object.assign(Object.assign({}, colour), { sizes: colour.sizes.map(size => {
            const color = findColor(productPrice === null || productPrice === void 0 ? void 0 : productPrice.colours, colour.colourId);
            const skuPrice = (color === null || color === void 0 ? void 0 : color.sizes) ? findSizeBySku(color === null || color === void 0 ? void 0 : color.sizes, size.sku) : null;
            return Object.assign(Object.assign({}, size), { prices: skuPrice ? skuPrice.prices : null, productDiscountPercentage: skuPrice ? skuPrice.discountPercentage : null, productDiscountAmount: skuPrice ? skuPrice.discountAmount : null });
        }) })));
    return Object.assign(Object.assign({}, product), { colours: productColours, ccExcluded: (_a = productPrice === null || productPrice === void 0 ? void 0 : productPrice.fulfillment) === null || _a === void 0 ? void 0 : _a.ccExcluded, hdExcluded: (_b = productPrice === null || productPrice === void 0 ? void 0 : productPrice.fulfillment) === null || _b === void 0 ? void 0 : _b.hdExcluded });
};
exports.mergeProductDetailPriceToProductLister = mergeProductDetailPriceToProductLister;
const fixProductColoursFallback = (product) => {
    var _a;
    return product && product.colours.length > 1
        ? Object.assign(Object.assign({}, product), { colourId: ((_a = product === null || product === void 0 ? void 0 : product.colours.find(colour => colour.availability > 0)) === null || _a === void 0 ? void 0 : _a.colourId) || (product === null || product === void 0 ? void 0 : product.colourId), colours: product === null || product === void 0 ? void 0 : product.colours.filter(colour => colour.availability > 0) }) : product;
};
exports.fixProductColoursFallback = fixProductColoursFallback;
const makeProductGroupObjects = (productGroupUniqueIds, alternativeQueryResults) => {
    const productGroupObjects = {};
    if (productGroupUniqueIds && alternativeQueryResults) {
        Object.keys(productGroupUniqueIds).forEach((productGroupKey) => {
            var _a, _b;
            productGroupObjects[`${productGroupKey}`] =
                (_b = (_a = alternativeQueryResults.find(item => item.alternativeQuery === productGroupUniqueIds[`${productGroupKey}`])) === null || _a === void 0 ? void 0 : _a.items) !== null && _b !== void 0 ? _b : [];
        });
    }
    return productGroupObjects;
};
exports.makeProductGroupObjects = makeProductGroupObjects;
const getProductGroupUniqueIds = (alternativeQueryResults) => {
    const mappedItems = {};
    if (alternativeQueryResults) {
        alternativeQueryResults.forEach(item => {
            if (item.alternativeQuery) {
                mappedItems[`${(0, general_util_1.uniqueId)('productGroup-')}`] = `${item.alternativeQuery}`;
            }
        });
    }
    return mappedItems;
};
exports.getProductGroupUniqueIds = getProductGroupUniqueIds;
const getDeliveryCharge = (deliveryCharges, deliveryOption) => {
    var _a, _b, _c;
    return (_c = (_b = (_a = deliveryCharges === null || deliveryCharges === void 0 ? void 0 : deliveryCharges.deliveryOptions) === null || _a === void 0 ? void 0 : _a.find(option => option.name === deliveryOption)) === null || _b === void 0 ? void 0 : _b.charges.find(charge => charge.deliveryCost === 0 && charge.minValue)) === null || _c === void 0 ? void 0 : _c.minValue;
};
exports.getDeliveryCharge = getDeliveryCharge;
const isOneSizeProduct = (sizes, oneSizeProductCode) => { var _a, _b; return (sizes === null || sizes === void 0 ? void 0 : sizes.length) === 1 && ((_b = (_a = sizes[0]) === null || _a === void 0 ? void 0 : _a.code) === null || _b === void 0 ? void 0 : _b.toLowerCase()) === oneSizeProductCode.toLowerCase(); };
exports.isOneSizeProduct = isOneSizeProduct;
const isOnlyOneSizeProduct = (sizes) => { var _a, _b; return (sizes === null || sizes === void 0 ? void 0 : sizes.length) === 1 && ((_b = (_a = sizes[0]) === null || _a === void 0 ? void 0 : _a.code) === null || _b === void 0 ? void 0 : _b.toLowerCase()) === 'one size'; };
exports.isOnlyOneSizeProduct = isOnlyOneSizeProduct;
//# sourceMappingURL=product.util.js.map